export default __webpack_public_path__ + "static/media/libraryVoiceOver.599d73f6.png";